import { render, staticRenderFns } from "./NotasTecnicas.vue?vue&type=template&id=60f9d688&scoped=true"
import script from "./NotasTecnicas.vue?vue&type=script&lang=js"
export * from "./NotasTecnicas.vue?vue&type=script&lang=js"
import style0 from "./NotasTecnicas.vue?vue&type=style&index=0&id=60f9d688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f9d688",
  null
  
)

export default component.exports